import AuthPage from '../Pages/AuthPage';

const LoginPage = () => {
    return (
        <AuthPage />
    );
};

export default LoginPage;